import {RequestBasis} from "./RequestBasis";

export class ProjectCandidatesInstrumentRequest extends RequestBasis {
  myTaskHash: string;
  projectInstrumentId: number;
  assessmentLangCode: string;

}
